import './MainMenuUserIcon.scss';
import React from 'react';
import { Icon } from 'semantic-ui-react';
import UserIcon from '../components/UserIcon';

export type MainMenuUserIconProps = {
  emailAddress: string;
  firstName: string;
  lastName: string;
  userId: string;
  hasProfilePicture: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export default function MainMenuUserIcon(props: MainMenuUserIconProps) {
  const { emailAddress, firstName, lastName, userId, hasProfilePicture } = props;
  return (
    <div className="main-menu-user-icon" onClick={props.onClick}>
      <UserIcon emailAddress={emailAddress} firstName={firstName} lastName={lastName} userId={userId} hasProfilePicture={hasProfilePicture} />
      <Icon name="sort down" />
    </div>
  );
}
